module.exports = __webpack_public_path__ + "img/msCalendar.5eabd09e.svg";